import React from 'react'
import '../loading.css'

const Loading = () => {
  return (
    <div class="loadingio-spinner-spinner-rwrfifmnsar">
      <div class="ldio-uvsg4dk6pgq">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Loading
